import React  from 'react'
import { View, StyleSheet, SafeAreaView } from 'react-native'
import { Icon, Text, useTheme } from '@ui-kitten/components'
import { cartItemNames } from '../SalesHistory/SalesHistoryScreen'
import { useTranslation } from 'react-i18next'
import { currencyFormatterAtom, storesDictAtom, usersDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import OperationsList from '../../components/OperationsList'

export default function TransfersScreen({ navigation }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const usersDict = useAtomValue(usersDictAtom)
  const storesDict = useAtomValue(storesDictAtom)
  const currencyFormatter = useAtomValue(currencyFormatterAtom)

  const renderItemFieldsToShow = (item, date) => {
    return (
      <>
        <View style={styles.dateTimeView}>
          <Icon name='swap-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {storesDict?.[(item.fromStore?.id || item.fromStore)]?.name + ' -> ' + storesDict?.[(item.toStore?.id || item.toStore)]?.name}
          </Text>
        </View>
        
        <View style={styles.dateTimeView}>
          <Icon name='clock-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {date}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='person-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {usersDict[item.cashierUID]?.name}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='credit-card-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {currencyFormatter.format(item.amount || 0)}
          </Text>
        </View>

        <Text>
          {cartItemNames(item.items || [item.product])}
        </Text>
      </>
    )
  }

  return (
    <SafeAreaView style={styles.container}>      
      <OperationsList collectionName='transfers' renderItemFieldsToShow={renderItemFieldsToShow} 
        navigation={navigation} dateField={'date'} additionalFilters={null} showStoreFilter={false}
        detailScreenName={'TransferDetail'} topView={() => {return null}} initialRange={null}
        showTotalSum={false} totalSumFormatter={null} totalSumField={null} 
        showAddButton={true} additionalDataValidation={() => {}} detailScreenParams={{}}
      />
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  icon: {
    marginRight: 4,
  },
  itemTitle: {
    marginRight: 25,
  },
  dateTimeView: {
    flexDirection: 'row',
    alignItems: 'center'
  },
});
